import { render, staticRenderFns } from "./ListKeteranganPO.vue?vue&type=template&id=40de04a6&scoped=true&"
import script from "./ListKeteranganPO.vue?vue&type=script&lang=js&"
export * from "./ListKeteranganPO.vue?vue&type=script&lang=js&"
import style0 from "../SalesForce.scss?vue&type=style&index=0&id=40de04a6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40de04a6",
  null
  
)

export default component.exports